import AuthPage from "../components/auth/AuthPage";

export default function Auth() {
  return <AuthPage />;
}
